import {
    type FC
} from "react";
import type IComposerAttachmentsProps from "./type";
import {
    warnOnce
} from "../../../../utils/development";

const ComposerAttachments: FC<IComposerAttachmentsProps> = () => {
    warnOnce({
        message: "Composer.Attachments: render it as a direct child of Composer; it only configures the attachment row."
    });

    return null;
};
export default ComposerAttachments;
